import { pGetNumberFaceReseauAsync } from '@/api/produit/produitReseau';

export default async function gestionFacesReelSurDispo(dispoByReseau, payload) {
  const facesReelsReaseaux = (await pGetNumberFaceReseauAsync(payload)).data.result;
  Object.keys(dispoByReseau).forEach((produitId) => {
    dispoByReseau[produitId].forEach((dispo) => {
      dispo.stock = facesReelsReaseaux[dispo.anneeSemaine]?.[produitId] || 0;
    });
  });
}
